<template>
  <div class="hello flex">
    <div class="left">
      <centerleft></centerleft>
    </div>
    <div class="right">
      <div class="head1">
        分享佣金
      </div>
      <div class="main1">
        <el-table :data="record" stripe border style="width: 100%;">
          <el-table-column prop="create_time" label="时间">
          </el-table-column>
          <el-table-column prop="change_type_zn" label="详情">
          </el-table-column>
          <el-table-column prop="money" label="金额">
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
          style="margin-top: 60px;" @current-change="current_change" v-if="pageshow">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import centerleft from '../../components/me/centerleft.vue'
  export default {
    data() {
      return {
        data: [],
        record: [],
        value: '',
        pageshow: true,
        page: 1,
        total: null,
        balance: ''
      }
    },
    components: {
      centerleft
    },
    created() {
      this.$http.walletFlow({
        per: 10,
        page: this.page,
        wallet_type: 1
      }).then(res => {
        this.record = res.data.list
        this.total = res.data.count
      })
    },
    methods: {
      current_change(e) {
        this.page = e
        this.$http.walletFlow({
          per: 10,
          page: this.page,
          wallet_type: 1
        }).then(res => {
          this.record = res.data.list
          this.total = res.data.count
        })
      },
      collect(item) {
        this.$http.schoolMark({
          school_id: item.id,
          cancel: 2
        }).then(res => {
          this.$message.success('操作成功')
          this.$http.schoolMarkLlist().then(res => {
            this.data = res.data.list
          })
        })
      },
      goUrl(url) {
        this.$router.push({
          path: url
        })
      },
      see(item) {
        console.log(item)
        if (item.from_type == 1) {
          this.$router.push(`/artificial?id=${item.id}&batch=${item.batch_name}`)
        } else if (item.from_type == 2) {
          this.$router.push(`/ai?id=${item.id}`)
        } else {
          this.$router.push(`/independent?id=${item.id}`)
        }
      },
      edit(item) {
        this.$router.push(`/artificial?id=${item.id}&batch=${item.batch_name}&type=ai`)
      },
      del(item) {
        this.$http.intentionDelete({
          id: item.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.$http.customCheckList({
              per: 10,
              page: this.page
            }).then(res => {
              this.record = res.data.list
              this.total = res.data.count
            })
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .schoolList {
    margin: 40px 0;
  }

  .caozuo {
    text-align: left;

    button {
      width: 58px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #19CACA;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .main1 {


    span {
      width: 100px;
    }

    .one {
      text-align: left;
      margin: 20px 0;
      justify-content: space-between;
    }

    .one1 {
      text-align: left;
      margin: 20px 0;
    }
  }

  .headImg {
    width: 70px;
    height: 70px;
    vertical-align: middle;
  }

  .head1 {
    width: 100%;
    height: 54px;
    background: #c10b17;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fffdfd;
    line-height: 54px;
    text-align: left;
    text-indent: 25px;
  }

  .right {
    width: 893px;
    height: 759px;
    border: 1px solid #EDEDED;
    border-radius: 4px;
    margin-left: 24px;
  }

  .left {
    width: 283px;
    height: 692px;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    .tixian {
      width: 70px;
      height: 32px;
      background: #19CACA;
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
    }

    .line2 {
      margin: 45px 32px 25px 32px;
      justify-content: space-between;

      span {
        color: #F9D681;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #F9D681;
      }
    }

    .line1 {
      margin-top: 27px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 11px;
      }
    }
  }

  .hello {
    width: 1300px;
    margin: 40px auto;
    align-items: flex-start;
  }

  .el-menu-vertical-demo {
    text-align: left !important;
  }

  .schoolList {
    margin: 40px 0;

    .one {
      .info1 {
        margin-left: 68px;

        img {
          width: 20px;
          height: 20px;
          margin-top: 16px;
        }
      }

      text-align: left;
      border-bottom: 1px solid #F2F2F2;
      padding-bottom: 37px;
      margin-top: 30px;

      button {
        width: 74px;
        height: 32px;
        background: #19CACA;
        border-radius: 4px;
        border: none;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 240px;
      }

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .type {
        margin-top: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }

      .name {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 29px;
      }

      .address {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/me/myBill.vue